import './navAnalytics.css';

export default function NavAnalytics() {
    return(
        <div>
            <svg width="22.69" height="22.69" viewBox="0 0 22.69 22.69">
                <path id="Icon_material-data-thresholding" data-name="Icon material-data-thresholding" d="M24.669,4.5H7.021A2.529,2.529,0,0,0,4.5,7.021V24.669A2.529,2.529,0,0,0,7.021,27.19H24.669a2.529,2.529,0,0,0,2.521-2.521V7.021A2.529,2.529,0,0,0,24.669,4.5Zm-10.5,6.517,2.521,2.521,4.626-4.626,1.777,1.777-6.4,6.416-2.521-2.521-3.782,3.782L8.609,16.589l5.559-5.572Zm-7.147,9.87H9.189L7.021,23.056ZM8.08,24.669l3.782-3.782h2.307l-3.782,3.782Zm4.992,0,3.782-3.782H18.9l-3.782,3.782Zm4.7,0,3.782-3.782H23.6l-3.782,3.782Zm6.9,0H22.488l2.181-2.181Z" transform="translate(-4.5 -4.5)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}